export const QRCodeConfig = {
  standalone: 384,
  default: 256,
};
